import { lazy, StrictMode, Suspense } from 'react'

import { createRoot } from 'react-dom/client'

import printBuildInfo from '@Core/utils/printBuildInfo'

import { ThemeProviderWrapper } from '@Core/ThemeProvideWrapperr'

import { FullscreenLoading } from '@Routes/system/FullscreenLoading'


const App = lazy(() =>
  import('./App'))


printBuildInfo()
const container = document.getElementById('root') as Element
const root = createRoot(container)

root.render((
  <StrictMode>
    <ThemeProviderWrapper>
      <Suspense fallback={<FullscreenLoading />}>
        <App />
      </Suspense>
    </ThemeProviderWrapper>
  </StrictMode>
))

// YT API
// handleClientLoad()
